import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { createCourse } from '../services/firestore'
import { ArrowLeft, BookOpen, FileText, MessageCircle, AlertCircle, Tag } from 'lucide-react'
import './CreateCourse.css'

const CreateCourse = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    whatsappLink: '',
    category: ''
  })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    if (!formData.name.trim()) {
      setError('El nombre de la clase es requerido')
      return
    }

    if (!formData.category) {
      setError('La categoría es requerida')
      return
    }

    setLoading(true)

    try {
      const result = await createCourse(formData, user.uid)

      if (result.success) {
        navigate(`/dashboard/course/${result.courseId}`)
      } else {
        setError(result.error || 'Error al crear la clase')
      }
    } catch (err) {
      setError(err.message || 'Error al crear la clase')
    }

    setLoading(false)
  }

  return (
    <div className="create-course-page">
      <div className="create-course-container">
        <button
          className="back-button"
          onClick={() => navigate('/dashboard')}
        >
          <ArrowLeft size={20} />
          Volver
        </button>

        <div className="form-header">
          <h1>
            <BookOpen size={32} />
            Paso 1: Crear Nueva Materia / Asignatura
          </h1>
          <p>Primero crea la materia general. Luego podrás agregar la fecha, sílabo y enlaces específicos para cada sesión.</p>
        </div>

        <form onSubmit={handleSubmit} className="course-form">
          <div className="form-group">
            <label htmlFor="name">
              <BookOpen size={18} />
              Nombre de la Clase *
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ej: Física 100"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="description">
              <FileText size={18} />
              Descripción
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe el contenido de la clase..."
              rows={4}
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="category">
              <Tag size={18} />
              Categoría *
            </label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              required
              disabled={loading}
            >
              <option value="">Selecciona una categoría</option>
              <option value="BIOLOGIA">BIOLOGIA</option>
              <option value="FISICA">FISICA</option>
              <option value="MATEMATICA">MATEMATICA</option>
              <option value="ELECTRICA">ELECTRICA</option>
              <option value="QUIMICA">QUIMICA</option>
              <option value="SALUD">SALUD</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="whatsappLink">
              <MessageCircle size={18} />
              Link de WhatsApp (Opcional)
            </label>
            <input
              type="url"
              id="whatsappLink"
              name="whatsappLink"
              value={formData.whatsappLink}
              onChange={handleChange}
              placeholder="https://chat.whatsapp.com/..."
              disabled={loading}
            />
          </div>

          {error && (
            <div className="error-message">
              <AlertCircle size={18} />
              <span>{error}</span>
            </div>
          )}

          <div className="form-actions">
            <button
              type="button"
              className="cancel-button"
              onClick={() => navigate('/dashboard')}
              disabled={loading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={loading}
            >
              {loading ? 'Creando...' : 'Crear Clase'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CreateCourse



